import { render, staticRenderFns } from "./insuplc.vue?vue&type=template&id=9ac4c108&"
import script from "./insuplc.vue?vue&type=script&lang=js&"
export * from "./insuplc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports